import classNames from 'classnames'
import React from 'react'
import { isMobile } from 'react-device-detect'
import useTranslation from '../../../../hooks/useTranslation'

export const ExtensionTooltip = (props: any) => {
  const { setOpenExtensionTooltip } = props
  const { t } = useTranslation()

  const handleModal = () => {
    setOpenExtensionTooltip((prev: boolean) => !prev)
  }

  const handleMoveLink = (url: string) => {
    if (url) {
      window.open(url, '_blank')
    }
  }

  return (
    <div
      className={classNames(
        'flex flex-col p-[16px] md:p-[32px] gap-[10px] bg-white    absolute border-[3px] border-main  rounded-[20px] ',
        {
          'w-[330px] bottom-8 left-0': !isMobile,
          'w-[280px] bottom-5 -left-32': isMobile,
        }
      )}
    >
      <p className=" md:leading-[19.2px] md:text-base  leading-[12px] text-[10px] flex justify-between items-center">
        <span className="font-bold text-[18px]">{t('productVideoEditor.extensionTooltip.title')}</span>
        <button className="" type="button" onClick={handleModal}>
          <img
            src="assets/img/Icon_x.png"
            alt="icon_x"
            height={24}
            width={24}
          />
        </button>
      </p>
      <p>
        {t('productVideoEditor.extensionTooltip.description')}
      </p>
      <p className="">
        <span>{t('productVideoEditor.extensionTooltip.featuresIntro')}</span>
        <ul className="text-main list-disc ml-5">
          <li>{t('productVideoEditor.extensionTooltip.features.autoInput')}</li>
          <li>{t('productVideoEditor.extensionTooltip.features.imagePreview')}</li>
          <li>{t('productVideoEditor.extensionTooltip.features.productManagement')}</li>
        </ul>
        <span>{t('productVideoEditor.extensionTooltip.featuresOutro')}</span>
      </p>
      <p
        className="flex gap-2  text-[14px] items-center cursor-pointer"
        onClick={() => {
          handleMoveLink('https://www.youtube.com/watch?v=VMJKnYM8rH4')
        }}
      >
        <img
          src="assets/img/icon_youtube.png"
          alt="icon_youtube"
          className="w-[26px] h-[26px]"
        />
        <span className="font-bold">{t('productVideoEditor.extensionTooltip.usageVideo')}</span>{' '}
      </p>
      <p
        className="flex gap-2  text-[14px] items-center cursor-pointer"
        onClick={() => {
          handleMoveLink('https://blog.fastseller.shop/fastcut_extention/')
        }}
      >
        <img
          src="assets/img/logo/fastcut-pay.jpg"
          alt="fastcut"
          className="w-[26px] h-[26px]"
        />
        <span className="font-bold">{t('productVideoEditor.extensionTooltip.troubleshootGuide')}</span>{' '}
      </p>
      <p
        className="flex gap-2  text-[14px] items-center cursor-pointer"
        onClick={() => {
          handleMoveLink(
            'https://chromewebstore.google.com/detail/meeeiblldcmbdhhaibnbpdiiknkoaakl?utm_source=item-share-cb'
          )
        }}
      >
        <img
          src="assets/img/logo/extension.png"
          alt="extension"
          className="w-[26px] h-[26px]"
        />
        <span className="font-bold">{t('productVideoEditor.extensionTooltip.installExtension')}</span>{' '}
      </p>
    </div>
  )
}
